import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const MENSAJES_API = {
    get: async () => {
        return await API.get('/mensajes').then(res => res.data);
    },
    new: async (mensaje) => {
        return API.post('/mensajes', mensaje, headers).then(res => res.data);
    },
    update: async(idMensaje, mensaje) => {
        return API.post(`/mensajes/${idMensaje}/update`, mensaje, headers).then(res => res.data);
    },
    toggle: async (mensaje) => {
        return API.post(`/mensajes/${mensaje.id}/status`, mensaje).then(res => res.data);
    },
    delete: async (idMensaje) => {
        return API.delete(`/mensajes/${idMensaje}`).then(res => res.data);
    }
}